import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { submitEnquiryForm } from "../../API/contact"; // adjust path
import "./EnquiryForm.css";
import { useLocation } from "react-router-dom";
import { SuccessModal } from "../../Common/SuccessModal";

function EnquiryForm() {
  const location = useLocation();
  const [inputValue, setInputValue] = useState({
    agencyName: "",
    contactPerson: "",
    email: "",
    travelDate: "",
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInput = (name, value) => {
    setInputValue((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // ✅ VALIDATION
  const validate = () => {
    let newErrors = {};

    if (!inputValue.agencyName.trim())
      newErrors.agencyName = "Agency name is required";

    if (!inputValue.contactPerson.trim())
      newErrors.contactPerson = "Contact person is required";

    if (!inputValue.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputValue.email)
    ) {
      newErrors.email = "Invalid email format";
    }

    if (!inputValue.travelDate)
      newErrors.travelDate = "Travel date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const payload = {
        agencyName: inputValue.agencyName,
        contactPerson: inputValue.contactPerson,
        email: inputValue.email,
        travelDate: new Date(inputValue.travelDate).toISOString(),
        slug: window.location.pathname, // ✅ added
      };

      await submitEnquiryForm(payload);

      setShowSuccess(true)

      setInputValue({
        agencyName: "",
        contactPerson: "",
        email: "",
        travelDate: "",
      });

    } catch (err) {
      alert(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="enquiryBox">
          <h3 className="title">Enquiry Form</h3>

          {/* Agency */}
          <Form.Group className="field">
            <label>Agency Name</label>
            <input
              type="text"
              placeholder="Enter your company / agency name"
              value={inputValue.agencyName}
              onChange={(e) => handleInput("agencyName", e.target.value)}
            />
            {errors.agencyName && <p className="error">{errors.agencyName}</p>}
          </Form.Group>

          {/* Contact */}
          <Form.Group className="field">
            <label>Contact Person</label>
            <input
              type="text"
              placeholder="Enter contact person name"
              value={inputValue.contactPerson}
              onChange={(e) => handleInput("contactPerson", e.target.value)}
            />
            {errors.contactPerson && (
              <p className="error">{errors.contactPerson}</p>
            )}
          </Form.Group>

          {/* Email */}
          <Form.Group className="field">
            <label>Business Email</label>
            <input
              type="email"
              placeholder="Official email address"
              value={inputValue.email}
              onChange={(e) => handleInput("email", e.target.value)}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </Form.Group>

          {/* Date */}
          <Form.Group className="field">
            <label>Travel Date</label>
            <input
              type="date"
              value={inputValue.travelDate}
              onChange={(e) => handleInput("travelDate", e.target.value)}
            />
            {errors.travelDate && (
              <p className="error">{errors.travelDate}</p>
            )}
          </Form.Group>

          <button type="submit" className="submitBtn" disabled={loading}>
            {loading ? "Submitting..." : "Request Quote"}
          </button>
        </div>
      </form>
      {showSuccess &&
        <div className="hrs-share-backdrop">
          <SuccessModal onClose={() => setShowSuccess(false)} />
        </div>
      }
    </>
  );
}

export default EnquiryForm;